// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './lib/css'
import './lib/script'
import './lib/global'

import Vue from 'vue'
import App from './App'
import { router } from './router'
import EventBus from './lib/eventBus.js'
import axios from 'axios'
import moment from 'moment'
import i18n from './plugins/i18n'
import FlagIcon from 'vue-flag-icon'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeartbeat ,faLungs , faTint , faSmoking , faProcedures , faUserMd, faHeadset , faClipboardList ,faAmbulance , faTachometerAlt , faWeight ,faFileMedical ,faHandshake, faMap , faHeadSideCough,faChild } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.prototype.moment = moment
Vue.prototype.$bus = EventBus
Vue.prototype.$http = axios
library.add([faHeartbeat,faLungs,faTint,faSmoking,faProcedures,faUserMd,faHeadset,faClipboardList,faAmbulance,faTachometerAlt,faWeight ,faFileMedical ,faHandshake, faMap , faHeadSideCough ,faChild])

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(FlagIcon)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD10FFzuYM4qyfnMims3xKu-gUSoZja_eI',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js